module.exports = __webpack_public_path__ + "img/sample-chemicalEngineer.ec3d7f40.webp";